export class AssetCountValueModel {
    assetCount: number;
    assetValue: number;
}